import { render, staticRenderFns } from "./PermitList.vue?vue&type=template&id=52961796"
import script from "./PermitList.vue?vue&type=script&lang=js"
export * from "./PermitList.vue?vue&type=script&lang=js"
import style0 from "./PermitList.vue?vue&type=style&index=0&id=52961796&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports